module.exports = __webpack_public_path__ + "media/app/components/MainNav/NavIcons/KamereoLogoMobileWhite.91b38a0c.svg";